import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[650px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Overhead%20editorial%20flat%20lay%20photography%20of%20premium%20lifestyle%20products%20array%20featuring%20designer%20sneakers%20luxury%20watches%20leather%20bags%20sunglasses%20and%20accessories%20artfully%20scattered%20on%20textured%20warm%20sandstone%20surface%20morning%20golden%20hour%20sunlight%20casting%20long%20soft%20shadows%20across%20the%20composition%20rich%20earthy%20terracotta%20sand%20beige%20and%20warm%20ivory%20tones%20mediterranean%20aesthetic%20sophisticated%20product%20catalog%20photography%20high%20end%20magazine%20editorial%20style%20generous%20copy%20space%20at%20top%20for%20text%20overlay&width=1600&height=900&seq=hero-2026-v7&orientation=landscape"
          alt="CSSBuy Spreadsheet products collage"
          title="CSSBuy Spreadsheet - Melhores produtos organizados"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-16 max-w-6xl mx-auto">
          <div className="flex-1 pt-16 md:pt-20">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-black text-background-50 leading-tight">
              <span className="block">{t('home:hero_title_line1')}</span>
              <span className="block text-accent-500">{t('home:hero_title_line2')}</span>
              <span className="block text-2xl md:text-4xl lg:text-5xl font-bold text-background-50/80 mt-2">
                {t('home:hero_title_line3')}
              </span>
            </h1>
          </div>

          <div className="flex-1 lg:pt-20">
            <p className="text-base md:text-lg text-background-50/85 leading-relaxed mb-6 max-w-md">
              {t('home:hero_subtitle')}
            </p>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-accent-500 text-background-50 font-semibold text-sm rounded-full hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              {t('home:hero_cta')}
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}